import React from 'react'
import { StyledBreakoutBoxWrapper } from './BreakoutBox.styled'

interface BreakoutBoxProps {}
const BreakoutBox: React.FC<BreakoutBoxProps> = ({ children }) => {
    return <StyledBreakoutBoxWrapper>{children}</StyledBreakoutBoxWrapper>
}

export default BreakoutBox
